import React from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from '@material-ui/icons/CloudUpload';

import { Button, ButtonProps } from './Button';

export const UploadButton = (props: ButtonProps): JSX.Element => {
  return (
    <Button type='button' {...props} startIcon={<Icon />}>
      <FormattedMessage
        id={'UploadButton.button.text'}
        defaultMessage={'Upload'}
      />
    </Button>
  );
};
